import { useContext } from 'react'
import { BreakpointsContext } from '../../components/layout/breakpoints-provider.client'
import styles from '../../assets/scss/components/home/home.module.scss'

export const useHome = () => {
  const { isXLargeUp } = useContext(BreakpointsContext)
  const canvasPadding = parseInt(styles['canvas-padding'])

  return {
    canvasWidth: (isXLargeUp ? 1934 : 1452) + canvasPadding * 2,
    canvasHeight: (isXLargeUp ? 1999 : 1504) + canvasPadding * 4,
  }
}
